export const searchJobs = /* GraphQL */ `
  query SearchJobs($input: SearchInput) {
    searchJobs(input: $input) {
      id
      companyId
      companyProfile {
        industries
        remotePolicy
        name
        bio
        hasHeadquarters
        hqAddress {
          formatted_address
          coordinate {
            lat
            lon
          }
        }
        emailAddress
        image
      }
      roleType
      datePosted
      jobTitle
      department
      experience
      companyName
      description
      aboutUs
      status
      remotePolicy
      timezonePolicy
      digitalNomadFriendly
      timezoneRanges {
        start
        end
      }
      officeFrequency {
        daysPerMonth
        daysPerWeek
      }
      officeLocations {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      featured
      wageIsHourly
      startSalaryRangeThousands
      endSalaryRangeThousands
      scraped
      scrapedUrl
      scrapedSource
      jobLogo
      willSponsor
    }
  }
`

export const searchJobsByTerm = /* GraphQL */ `
  query SearchJobsByTerm($input: SearchJobsByTermInput) {
    searchJobsByTerm(input: $input) {
      id
      companyId
      companyProfile {
        industries
        remotePolicy
        name
        bio
        hasHeadquarters
        hqAddress {
          formatted_address
          coordinate {
            lat
            lon
          }
        }
        emailAddress
        image
      }
      roleType
      datePosted
      jobTitle
      department
      experience
      companyName
      description
      aboutUs
      status
      remotePolicy
      timezonePolicy
      digitalNomadFriendly
      timezoneRanges {
        start
        end
      }
      officeFrequency {
        daysPerMonth
        daysPerWeek
      }
      officeLocations {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      featured
      wageIsHourly
      startSalaryRangeThousands
      endSalaryRangeThousands
      scraped
      scrapedUrl
      scrapedSource
      jobLogo
      willSponsor
    }
  }
`;

export const searchJobsByLocation = /* GraphQL */ `
  query SearchJobsByLocation($input: SearchJobsByLocationInput) {
    searchJobsByLocation(input: $input) {
      aboutUs
      companyId
      communications {
        emails
        phone
      }
      companyWebsite
      companyName
      dateCreated
      dateModified
      datePosted
      deleted
      department
      description
      digitalNomadFriendly
      elite
      endSalaryRangeThousands
      experience
      featured
      featuredRank
      flexibleHours
      id
      jobLogo
      jobTitle
      officeFrequency {
        daysPerMonth
        daysPerWeek
      }
      officeLocations {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      remoteFirst
      remotePolicy
      roleType
      scraped
      scrapedSource
      scrapedUrl
      startSalaryRangeThousands
      status
      tags
      timezonePolicy
      timezoneRanges {
        start
        end
      }
      wageIsHourly
      willSponsor
      workFromAnywhere
    }
  }
`;

export const updateAutoApply = `mutation UpdateAutoApply($input: UpdateAutoApplyInput) {
  updateAutoApply(input: $input) {
    id
    jobSeekerId
    subId
    autoGenerateCoverLetter
    autoGenerateCoverLetterTone
    blockedCompanyList
    resumeText
    coverLetter
    aiGenerateCoverLetter
    searchCustomInstructions
    coverLetterTone
    openToRelocation
    languagesSpoken
    age
    references {
      name
      email
      phone
      relationship
    }
    genderIdentity
    draft
    email
    isActive
    firstName
    lastName
    remote
    hybrid
    onsite
    jobTitles
    negativeJobTitles
    education {
      institution
      certification
      concentration
      dateStarted
      dateCompleted
      inProgress
      description
    }
    educationHistory {
      institution
      certification
      concentration
      dateStarted
      dateCompleted
      inProgress
      description
    }
    experienceLevels
    excludeCompanyNames
    expiresAt
    subscribedOn
    plan
    applicationCount
    paymentFailed
    autoLocations {
      location {
        formatted_address
        coordinate {
          lat
          lon
        }
      }
      country
      region
      area
    }
    location {
      formatted_address
      coordinate {
        lat
        lon
      }
    }
    country
    region
    area
    customPreference
    appliedUrls
    salaryMin
    salaryMax
    salaryRange
    searchTags
    prompt
    phone
    address
    currentCompany
    linkedinProfile
    githubProfile
    website
    gender
    pronouns
    hispanic
    race
    paused
    disabled
    veteran
    countryAuthorization {
      countryAuthorization
      authorizationType
      requiresSponsorship
    }
    secretClearance
    appCountToday
    appCountDateUpdated
    maxPerDay
    maxPerCo
    resumeUrl
    resumeName
    trial
    trialExpired
    dateCreated
    cancelled
  }
}
`;